import React, { useEffect, useState } from "react";
import "../styles/booking-form.css";

import { Button, Form, FormGroup, Input } from "reactstrap";
import { FinancialGoal, transmission } from "../util/datasource";
import { GetAllBrands, GetCarNames } from "../util/api";

const BookingForm = () => {
  const [carBrands, setCarBrands] = useState([]);
  const [carName, setCarName] = useState([]);
  const [formData, setFormData] = useState({
    transmission: "",
    financialGoal: "",
    brand: "",
    carName: "",
    carUsage: "",
    carSharingFrequency: "",
    advanceNotice: "",
    longestTrip: "",
    doors: "",
    seats: "",
    childSeats: "",
    rent: "",
    odoMeter: "",
    description: "",
    registrationNumber: "",
    registrationYear: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    getHostCarBrand();
  }, []);

  const getHostCarBrand = () => {
    GetAllBrands().then((res) => {
      console.log("res", res);
      const options = res.map((car) => ({
        value: car.brandName.toLowerCase(),
        label: car.brandName,
      }));
      setCarBrands(options);
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Handle the selected file here, e.g., display the image preview or upload it
      console.log("Selected file:", file);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    // Add validation logic for each field here
    if (!formData.transmission) {
      newErrors.transmission = "Transmission is required";
    }

    if (!formData.financialGoal) {
      newErrors.financialGoal = "Financial goal is required";
    }

    if (!formData.brand) {
      newErrors.brand = "Brand is required";
    }

    if (!formData.carName) {
      newErrors.carName = "Car name is required";
    }

    if (!formData.carUsage) {
      newErrors.carUsage = "Car usage is required";
    }

    if (!formData.carSharingFrequency) {
      newErrors.carSharingFrequency = "Car sharing frequency is required";
    }

    if (!formData.advanceNotice) {
      newErrors.advanceNotice = "Advance notice is required";
    }

    if (!formData.longestTrip) {
      newErrors.longestTrip = "Longest possible trip is required";
    }

    if (!formData.doors) {
      newErrors.doors = "Number of doors is required";
    }

    if (!formData.seats) {
      newErrors.seats = "Number of seats is required";
    }

    if (!formData.childSeats) {
      newErrors.childSeats = "Number of child seats is required";
    }

    if (!formData.rent) {
      newErrors.rent = "Car rent is required";
    }

    if (!formData.odoMeter) {
      newErrors.odoMeter = "Odometer value is required";
    }

    if (!formData.description) {
      newErrors.description = "Description is required";
    }

    if (!formData.registrationNumber) {
      newErrors.registrationNumber = "Registration number is required";
    }

    if (!formData.registrationYear) {
      newErrors.registrationYear = "Registration year is required";
    }

    return newErrors;
  };

  const handleBrandChange = (event) => {
    const selectedValue = event.target.value;
    console.log("selected", selectedValue);
    GetCarNames(selectedValue).then((res) => {
      const options = res.map((car) => ({
        value: car.carName.toLowerCase(),
        label: car.carName,
      }));
      setCarName(options);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    setErrors(newErrors);

    // If there are no errors, proceed with form submission
    if (Object.keys(newErrors).length === 0) {
      console.log("Form data:", formData);
      // Perform form submission logic here (e.g., API call)
      // Reset the form data after successful submission
      setFormData({
        transmission: "",
        financialGoal: "",
        brand: "",
        carName: "",
        carUsage: "",
        carSharingFrequency: "",
        advanceNotice: "",
        longestTrip: "",
        doors: "",
        seats: "",
        childSeats: "",
        rent: "",
        odoMeter: "",
        description: "",
        registrationNumber: "",
        registrationYear: "",
      });
      // Clear validation errors
      setErrors({});
    }
  };

  console.log("errors", errors);
  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup className="booking__form d-inline-block me-4 mb-4">
        <p>What is the transmission of your car</p>
        <select name="" id="">
          <option value="">Select...</option>
          {transmission.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {errors.transmission && (
          <span className="error">{errors.transmission}</span>
        )}
        {/* <Input type="text" placeholder="Your First Name" /> */}
      </FormGroup>
      <FormGroup className="booking__form d-inline-block ms-1 mb-4">
        {/* <Input type="text" placeholder="Your Last Name" /> */}
        <p>What is your primary financial goal for sharing this car to hiso </p>
        <select name="" id="">
          <option value="">Select...</option>
          {FinancialGoal.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {errors.financialGoal && (
          <span className="error">{errors.financialGoal}</span>
        )}
      </FormGroup>
      <FormGroup className="booking__form d-inline-block me-4 mb-4">
        <p>What is the brand of your car</p>
        <select name="" id="" onChange={handleBrandChange}>
          <option value="">Select...</option>
          {carBrands.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {errors.brand && <span className="error">{errors.brand}</span>}
        {/* <Input type="text" placeholder="Your First Name" /> */}
      </FormGroup>
      <FormGroup className="booking__form d-inline-block ms-1 mb-4">
        {/* <Input type="text" placeholder="Your Last Name" /> */}
        <p>What is name of you car</p>
        <select name="" id="">
          <option value="">Select...</option>
          {carName.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {errors.carName && <span className="error">{errors.carName}</span>}
      </FormGroup>
      <FormGroup className="booking__form d-inline-block me-4 mb-4">
        {/* <Input type="email" placeholder="Your Email Name" /> */}
        <p>How often you and your family use this car?</p>
        <select name="" id="">
          <option value="">Select...</option>
          {FinancialGoal.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {errors.carUsage && <span className="error">{errors.carUsage}</span>}
      </FormGroup>

      <FormGroup className="booking__form d-inline-block ms-1 mb-4">
        {/* <Input type="number" placeholder="Your Phone Number" /> */}
        <p>How often you want to share this car?</p>
        <select name="" id="">
          <option value="">Select...</option>
          {FinancialGoal.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {errors.carSharingFrequency && (
          <span className="error">{errors.carSharingFrequency}</span>
        )}
      </FormGroup>

      <FormGroup className="booking__form d-inline-block me-4 mb-4">
        {/* <Input type="text" placeholder="From Address" /> */}
        <p>How much advance notice you need before trip starts?</p>
        <select name="" id="">
          <option value="">Select...</option>
          {FinancialGoal.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </FormGroup>

      <FormGroup className="booking__form d-inline-block ms-1 mb-4">
        {/* <Input type="text" placeholder="To Address" /> */}
        <p>How much longest posible trip you accept?</p>
        <select name="" id="">
          <option value="">Select...</option>
          {FinancialGoal.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </FormGroup>

      <FormGroup className="booking__form d-inline-block me-4 mb-4">
        <p>How many doors in your car?</p>
        <Input type="text" placeholder="Doors" />
      </FormGroup>

      <FormGroup className="booking__form d-inline-block ms-1 mb-3">
        <p>How many seats in your car?</p>
        <Input type="text" placeholder="Seats" />
      </FormGroup>

      <FormGroup className="booking__form d-inline-block me-4 mb-3">
        <p>How many child seats in your car?</p>
        <Input type="text" placeholder="Child Seats" />
      </FormGroup>

      <FormGroup className="booking__form d-inline-block ms-1 mb-4">
        <p>Tell per day car rent in usd</p>
        <Input type="text" placeholder="Rent" />
      </FormGroup>
      <FormGroup className="booking__form d-inline-block me-4 mb-3">
        <p>Please enter driven millage as an odo meter</p>
        <Input type="text" placeholder="Odo Meter" />
      </FormGroup>

      <FormGroup className="booking__form d-inline-block ms-1 mb-4">
        <p>Tell guest what makes your car unique and why</p>
        <Input type="text" placeholder="Discription" />
      </FormGroup>
      <FormGroup className="booking__form d-inline-block me-4 mb-3">
        <p>Your license plate information won't be publicaly visible</p>
        <Input type="text" placeholder="Registration number" />
      </FormGroup>

      <FormGroup className="booking__form d-inline-block ms-1 mb-4">
        <p>Your car registeration year</p>
        <Input type="text" placeholder="Registration Year" />
      </FormGroup>
      <FormGroup className="booking__form d-inline-block me-4 mb-3">
        <p>Upload cover image of your image</p>
        <input type="file" accept="image/*" onChange={handleFileChange} />
      </FormGroup>
      <Button type="submit">Submit</Button>
    </Form>
  );
};

export default BookingForm;
